import ModalSuccessPaymentQuotation from "./ModalSuccessPaymentQuotation";

export default ModalSuccessPaymentQuotation;
